/* eslint-disable */ 
import React, { Suspense } from 'react';
import './App.css';
// 
// import SceneComponent from './components/SceneComponent.jsx';
const SceneComponent = React.lazy(() => import('./components/SceneComponent.jsx'));

function App() {
	return (
		<div>
			{/* <a 
				style={{
					position: 'absolute',
					left: 10,
					top: 10,
					color: 'white',
					zIndex: '10',
				}}
				href="https://playground.babylonjs.com/#3DK8PZ#4" 
			>
				this app is Not properly structured, so there is No smoothness.
			</a> */}
			<div
				style={{
					height: '100vh',
					width: '100%',
					// position: 'relative',
					overflow: 'hidden',
				}}
			>
				<Suspense
					fallback={
						<div
							style={{
								backgroundColor: '#ffffff',
								zIndex: 21000, 
								position: 'absolute',
								left: '50%', 
								top: '50%', 
								height: '100%', 
								width: '100%', 
								transform: 'translate(-50%, -50%)',
							}}
						>
							<img 
								style={{
									backgroundColor: '#ffffff',
									zIndex: 21000, 
									position: 'absolute',
									left: '50%', 
									top: '50%', 
									height: '300px', 
									width: '300px', 
									transform: 'translate(-50%, -50%)',
								}}
								src={"https://gitlab.com/ravensoni/assets/-/raw/master/loadergif/shedanim.gif"} alt="loading..." 
							/>
						</div>
					}
				>
					<SceneComponent/>
				</Suspense>
			</div>
		</div>
	);
}

export default App;
